import { toast } from "react-toastify";
import { MediaRole } from "../../../../codegen/graphql";
import { api } from "../../../utils/api";


export async function SupplierCard_importAliexpressImages(
  adId: string,
  images: any[],
  roles: MediaRole[],
) {
  await api.post('/aliexpress/import-images', {
    adId,
    urls: images.map((image) => image.url),
    roles,
  });
  toast.success('Images téléchargées avec succès');
};
